import { create } from 'zustand';

interface CookieStore {
  selectedCookies: string[];
  setSelectedCookies: (cookies: string[]) => void;
}

export const useCookieStore = create<CookieStore>((set) => ({
  selectedCookies: [],
  setSelectedCookies: (cookies) => set({ selectedCookies: cookies }),
}));
